import { CroppedBoundingBoxImage } from "@/components/ImageCrop";
import { Confidence } from "@/components/estimation-details/Rooms/Lines/Confidence";
import { useEstimateDetail } from "@/hooks/useEstimateDetail";
import type { Prediction } from "@/interfaces/estimate-detail";
import type { File } from "@/interfaces/estimation.interface";
import { getStorageFileUrl } from "@/util/get-storage-file-url";
import { boxForPrediction, getEstimateFileRoomId, highestScoringPredictionForFile } from "./photos.utils";

interface RoomPhotoGalleryProps {
  photos: File[];
  onSelect: (uploadId: string) => void;
  estimateId: string;
  predictions?: Prediction[];
}

export function RoomPhotoGallery({ photos, onSelect, estimateId, predictions }: RoomPhotoGalleryProps) {
  const { currentRoom } = useEstimateDetail(estimateId);
  const photosForRoom = photos.filter((photo) => {
    const photoRoomId = getEstimateFileRoomId(photo);
    return photoRoomId === currentRoom?.id;
  });

  return (
    <div className="flex flex-wrap gap-4 overflow-y-scroll p-4">
      {photosForRoom.map((currentFile) => {
        const prediction = highestScoringPredictionForFile(currentFile.uploadId || "", predictions);

        return (
          <button
            key={currentFile.uploadId}
            type="button"
            aria-label={`View ${currentFile.originalname || "room photo"}`}
            onClick={() => onSelect(currentFile.uploadId!)}
            className="w-[250px] cursor-pointer rounded-lg border border-gray-200 bg-white p-3 text-left shadow-md"
          >
            <CroppedBoundingBoxImage
              url={getStorageFileUrl(currentFile.remotePath)}
              paddingPixels={50}
              rect={prediction ? boxForPrediction(prediction) : undefined}
              box
              className="mb-3 w-full rounded"
            />

            <div className="space-y-1">
              {prediction &&
                [prediction].map((p, index) => (
                  <div key={`${p.objectId}-${index}`} className="flex w-full items-center justify-between text-sm">
                    <span className="w-full text-gray-900">{p.objectId?.replace("_", " ") || "Unknown"}</span>
                    <span>
                      <Confidence percentage={p?.confidence ? Math.round(p.confidence * 100) : 0} />
                    </span>
                  </div>
                ))}
            </div>
          </button>
        );
      })}
    </div>
  );
}
